<div class="navbar bg-none text-neutral-content items-center py-3 pr-6">
  <div class="navbar-start"></div>
  <div class="navbar-center">
    <app-logo class="text-kek-purple" [clickable]="logoClickable"></app-logo>
  </div>
  <div class="navbar-end">
    <button (click)="toggleMenu()" class="swap swap-rotate relative p-0 m-0 z-[60]" [class.swap-active]="swapActive">
      <svg
        class="swap-off fill-current w-8 h-8"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        aria-hidden="true"
      >
        <path d="M64,384H448V341.33H64Zm0-106.67H448V234.67H64ZM64,128v42.67H448V128Z" />
      </svg>
      <svg
        class="swap-on fill-current w-8 h-8"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        aria-hidden="true"
      >
        <polygon points="400 145.49 366.51 112 256 222.51 145.49 112 112 145.49 222.51 256 112 366.51 145.49 400 256 289.49 366.51 400 400 366.51 289.49 256 400 145.49" />
      </svg>
    </button>
  </div>
</div>

<!-- Side Menu Overlay -->
@if (menuOpen) {
  <div class="fixed inset-0 bg-black bg-opacity-50 z-40" (click)="closeMenu()"></div>
}

<!-- Side Menu Panel -->
<div class="side-menu-panel w-80 duration-500"
     [class.translate-x-full]="!menuOpen"
     [class.translate-x-0]="menuOpen">
  <!-- Menu Header -->
  <div class="side-menu-header"
       [ngClass]="menuOpen ? 'opacity-100 transition-opacity duration-300 delay-200' : 'opacity-0 transition-opacity duration-300'">
    <span class="font-spaceGrotesk font-bold text-[1.75rem]">Menu</span>
  </div>
  

  <!-- Menu Items -->
  <div class="max-h-[500px] space-y-1 overflow-y-scroll px-4 py-4"
       [ngClass]="menuOpen ? 'opacity-100 transition-opacity duration-300 delay-200' : 'opacity-0 transition-opacity duration-300'">
    
    <ng-content/>

    <button (click)="showComingSoonToast(); closeMenu()"
            class="side-menu-item">
      <span class="material-icons">record_voice_over</span>
      <span class="inter-400 text-[1.125rem]">Text to Speech</span>
    </button>

    <button (click)="toggleTheme(); closeMenu()"
            class="side-menu-item">
  @if (!isDarkTheme()) {
        <svg
          class="fill-current w-6 h-6 flex-shrink-0"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
        <path
          d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z"
        />
        </svg>
      }
  @if (isDarkTheme()) {
        <svg
          class="fill-current w-6 h-6 flex-shrink-0"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
        <path
          d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12,.29a1,1,0,0,0,.7-.29l.71-.71a1,1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-9,8a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z"
        />
        </svg>
      }
      <span class="inter-400 text-[1.125rem]">Toggle Theme</span>
    </button>

  </div>
</div>
